/**
 * Singleton config reader for Magento window configs (injected via PHTML)
 * Reads once and caches - no React dependency needed
 *
 * Reads from: window.reactConfig.catalog.*
 * Magento PHTML sets: window.reactConfig.catalog = { app, attachments, productInfo, tbi }
 */
import type {
  ConfigType,
  ConfigManufacturer,
  ConfigAttachments,
  TbiConfigType,
  ShippingConfig,
} from '../types'

export interface ProductViewConfig {
  productSku: string
  appConfig: ConfigType
  productInfoConfig: ConfigManufacturer
  configAttachments: ConfigAttachments
  tbiConfig: TbiConfigType | null
  shippingConfig: ShippingConfig
}

const DEFAULT_SHIPPING: ShippingConfig = {
  shippingPrice: 0,
  shippingPriceFormatted: '',
  freeShippingThreshold: 0,
  freeShippingThresholdFormatted: '',
  currencyCode: 'RON',
}

let configCache: ProductViewConfig | null = null

export function getProductViewConfig(): ProductViewConfig {
  if (configCache) return configCache

  const catalog = window.reactConfig?.catalog

  configCache = {
    productSku: catalog?.productSku ?? '',
    appConfig: catalog?.app ?? { attributes: {} },
    productInfoConfig: catalog?.productInfo ?? { attributes: { logoUrl: '' } },
    configAttachments: catalog?.attachments ?? { attributes: [] },
    tbiConfig: catalog?.tbi ?? null,
    shippingConfig: catalog?.shipping ?? DEFAULT_SHIPPING,
  }

  return configCache
}
